import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { DualScoringBoardContainer } from "app/pages/sales-intelligence/modules/lead-scoring-agent/containers/DualScoringBoardContainer";
import type { LeadsSearchAllFiltersTypes } from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsSearchFilters.dto";
import type { IScoringRuleDto } from "app/pages/sales-intelligence/sub-modules/signals/types/scoring-config";

const PLAYBOOKS_SEGMENT_TRANSLATION_KEYS = {
    all: "si.playbooks.segment.all",
    shared: "si.playbooks.segment.shared",
    private: "si.playbooks.segment.private",
} as const;

const PLAYBOOKS_ADD_RULE_TRANSLATION_KEYS = {
    privateKey: "si.playbooks.wizard.score_criteria.add_private_rule",
    sharedKey: "si.playbooks.wizard.score_criteria.add_shared_rule",
} as const;

type Props = {
    filtersList: readonly IFilterInstance<LeadsSearchAllFiltersTypes>[];
    isBootstrapping?: boolean;
    selectedRuleId: string | null;
    onSelect: (ruleId: string) => void;
    getRuleUsage?: (rule: IScoringRuleDto) => readonly string[];
};

export const PlaybookScoringBoardContainer = ({
    filtersList,
    isBootstrapping = false,
    selectedRuleId,
    onSelect,
    getRuleUsage,
}: Props) => (
    <DualScoringBoardContainer
        filtersList={filtersList}
        isBootstrapping={isBootstrapping}
        segmentTranslationKeys={PLAYBOOKS_SEGMENT_TRANSLATION_KEYS}
        addRuleTranslationKeys={PLAYBOOKS_ADD_RULE_TRANSLATION_KEYS}
        automationPrefix="playbook-scoring-board"
        applicableForUserOnly
        selectedRuleId={selectedRuleId}
        onSelect={onSelect}
        getRuleUsage={getRuleUsage}
    />
);
